export {
  default as meetingSpace,
  ReactComponent as MeetingSpace,
} from '@assets/icons/features-and-amenities/meeting-space.svg'    
